import { togglzService } from "../_services";
import { getField, updateField } from "vuex-map-fields";
import * as dayjs from "dayjs";

const setState = () => {
  return {
    vrs: {
      loading: false,
      reloading: false,
      submitting: false,
    },
    togglz: {
      registrationOpen: false,
      badgeMailingOpen: false,
      onsiteOpen: false,
      alphaDinnerOpen: false,
      alphaEventsOpen: false,
      dealersOpen: false,
      panelsOpen: false,
      djsOpen: false,
      danceCompOpen: false,
      volunteersOpen: false,
      casinoVolsOpen: false,
      alphasOpen: false,
      upperTiersOpen: false,
      earlyBirdOpen: false,
      earlyBirdClosedAt: null,
      charityOpen: false,
      hotelOpen: false,
      lagoonOpen: false,
      checkinOpen: false,
      casinoOpen: false,
    },
    conVars: {},
    conVarsLoaded: false,
    detailedConVars: {},
    // RAWR this is for when settings get migrated from main.js into the db
    // conVars: {
    //   CONVENTION_YEAR: "2000",
    //   FIRST_DAY_OF_CONVENTION: "2000-01-01",
    //   LAST_DAY_OF_CONVENTION: "2000-01-01",
    //   TWENTYONE_CUTOFF: "2000-01-01",
    //   EIGHTEEN_CUTOFF: "2000-01-01",
    //   SIXTEEN_CUTOFF: "2000-01-01",
    //   THIRTEEN_CUTOFF: "2000-01-01",
    //   SINGLEDAY_REGISTRATION_PRICE: "00.0",
    //   TWODAY_REGISTRATION_PRICE: "00.0",
    //   BASIC_REGISTRATION_PRICE: "00.0",
    //   ULTIMATE_REGISTRATION_PRICE: "00.0",
    //   ALPHA_REGISTRATION_PRICE: "00.0",
    //   EB_BASIC_REGISTRATION_PRICE: "00.0",
    //   EB_ULTIMATE_REGISTRATION_PRICE: "00.0",
    //   EB_ALPHA_REGISTRATION_PRICE: "00.0",
    //   EB_CUTOFF_DATE: "2000-01-01",
    //   LAGOON_PRICE: "00.00",
    //   LAGOON_FULL_PRICE: "00.00",
    //   LAGOON_DATE: "2000-01-01",
    //   PROCESSING_FEES: "0.0",
    //   VOLUNTEER_OPEN: "January",
    //   ALPHA_DINNER: "Monday, January 1",
    //   ALPHA_DINNER_TIME: "12:00 AM",
    //   ALPHA_DINNER_PRICE: "50",
    //   AD_DEADLINE: "January 1",
    //   SINGLE_TABLE_PRICE: "00.0",
    //   DOUBLE_TABLE_PRICE: "00.0",
    //   DEALER_CLOSING_DATE: "2000-01-01",
    //   HOTEL_LOTTERY_CLOSING: "2000-01-01",
    //   CHARITY_OPEN: "January",
    //   CHARITY_APP_CLOSE: "Monday, January 1",
    //   DANCE_APP_OPEN: "January",
    //   DANCE_APP_CLOSE: "Monday, January 1",
    //   DANCE_APP_DETERMINATION: "Monday, January 1",
    //   DJ_APP_OPEN: "January",
    //   DJ_APP_CLOSE: "Monday, January 1",
    //   DJ_APP_DETERMINATION: "January 1",
    // }
  };
};

const state = setState();

const actions = {
  resetState({ commit }) {
    commit("resetStateNow");
  },
  getTogglz({ commit, dispatch }) {
    commit("getTogglzRequest");

    togglzService.getTogglz().then(
      (toggle) => commit("getTogglzSuccess", toggle),
      (error) => {
        commit("getTogglzFailure", error);
      }
    );
  },

  reloadTogglz({ commit, dispatch }) {
    commit("reloadTogglzRequest");

    togglzService.getTogglz().then(
      (toggle) => commit("reloadTogglzSuccess", toggle),
      (error) => {
        commit("reloadTogglzFailure", error);
      }
    );
  },

  saveTogglz({ commit, dispatch, state }, toggle) {
    commit("saveTogglzRequest", toggle);

    togglzService.saveTogglz(toggle).then(
      (volApp) => {
        commit("saveTogglzSuccess", volApp);
        let msg = "Toggle updated successfully!";
        dispatch("alert/success", msg, {
          root: true,
        });
      },
      (error) => {
        commit("saveTogglzFailure", error.toString());
        dispatch("alert/error", error, {
          root: true,
        });
      }
    );
  },

  getConVars({ commit, dispatch }) {
    commit("getConVarsRequest");
    // console.log("getConVars");
    togglzService.getConVar().then(
      (conVar) => commit("getConVarsSuccess", conVar),
      (error) => {
        commit("getConVarsFailure", error);
      }
    );
  },

  reloadConVars({ commit, dispatch }) {
    commit("reloadConVarsRequest");

    togglzService.getConVar().then(
      (conVar) => commit("reloadConVarsSuccess", conVar),
      (error) => {
        commit("reloadConVarsFailure", error);
      }
    );
  },

  saveConVars({ commit, dispatch, state }, conVar) {
    commit("saveConVarsRequest", conVar);

    togglzService.saveConVar(conVar).then(
      (volApp) => {
        //deliberate, no need to write separate handler
        commit("getConVarsSuccess", volApp);
        let msg = "Setting updated successfully!";
        dispatch("alert/success", msg, {
          root: true,
        });
      },
      (error) => {
        commit("saveConVarsFailure", error.toString());
        dispatch("alert/error", error, {
          root: true,
        });
      }
    );
  },
};

const getters = {
  getField,
};

const mutations = {
  updateField,
  resetStateNow(state) {
    Object.assign(state, setState());
  },
  getTogglzRequest(state) {
    state.vrs.loading = true;
  },
  getTogglzSuccess(state, toggle) {
    state.togglz = toggle;
    // console.log("getTogglzSuccess",state.togglz);
    state.vrs.loading = false;
  },
  getTogglzFailure(state, error) {
    // console.log("getTogglzFailure");
    state.vrs.loading = false;
  },
  reloadTogglzRequest(state) {
    state.vrs.reloading = true;
  },
  reloadTogglzSuccess(state, toggle) {
    state.togglz = toggle;
    state.vrs.reloading = false;
  },
  reTogglzFailure(state, error) {
    state.vrs.reloading = false;
  },
  saveTogglzRequest(state, toggle) {
    state.vrs.submitting = true;
  },
  saveTogglzSuccess(state, toggle) {
    state.togglz = toggle;
    state.vrs.submitting = false;
  },
  saveTogglzFailure(state, error) {
    state.vrs.submitting = false;
  },

  getConVarsRequest(state) {
    state.vrs.loading = true;
    state.conVarsLoaded = false;
  },
  getConVarsSuccess(state, conVar) {
    state.detailedConVars = conVar;
    for (const cv of conVar) {
      let newVar;
      switch (cv.varType) {
        case "date":
          newVar = new Date(cv.data);
          break;
        case "number":
          if (cv.data.includes(".")) newVar = parseFloat(cv.data);
          else newVar = parseInt(cv.data);
          break;
        default:
          newVar = cv.data;
          break;
      }
      state.conVars[cv.name] = newVar;
    }
    //now add a few helpers
    let cutoffs = [
      {
        num: 21,
        name: "TWENTYONE",
      },
      {
        num: 18,
        name: "EIGHTEEN",
      },
      {
        num: 16,
        name: "SIXTEEN",
      },
      {
        num: 13,
        name: "THIRTEEN",
      },
    ];
    for (const a of cutoffs) {
      state.conVars[a.name + "_CUTOFF"] = dayjs(
        state.conVars.FIRST_DAY_OF_CONVENTION
      ).subtract(a.num, "year");
    }
    state.vrs.loading = false;
    // console.log("getConVarsSuccess");
    state.conVarsLoaded = true;
  },
  getConVarsFailure(state, error) {
    // console.log("getConVarsFailure");
    state.vrs.loading = false;
    state.conVarsLoaded = false;
  },
  reloadConVarsRequest(state) {
    state.vrs.reloading = true;
  },
  reloadConVarsSuccess(state, conVar) {
    state.conVar = conVar;
    state.vrs.reloading = false;
  },
  reConVarsFailure(state, error) {
    state.vrs.reloading = false;
  },
  saveConVarsRequest(state, conVar) {
    state.vrs.submitting = true;
  },
  saveConVarsSuccess(state, conVar) {
    state.conVar = conVar;
    state.vrs.submitting = false;
  },
  saveConVarsFailure(state, error) {
    state.vrs.submitting = false;
  },
};

export const togglz = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
